import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import Loader from "../component/loader";
import {
  Input,
  regexEmail,
  regexMobile,
  Select,
} from "../../component/form-control";
import {
  browserLogs,
  confirm,
  currencyFormat,
  rptActualUse,
  toast,
  toastRPT,
} from "../../component/component";
import moment from "moment";
import { rptKind, rptYear, rptQtr } from "../../component/component";
import DataPrivacy from "../component/data-privacy";
import { pgw } from "../../component/api";

const environment = process.env;

const RptRow = ({ row, remove, key_index, handleDropDown }) => {
  return row.items.map((item, index) => (
    <tr
      key={index}
      className={`${
        index % 2 === 1 && "bg-gray-100"
      } text-sm hover:bg-gray-300`}
    >
      {index === 0 && (
        <td
          className="p-2 border"
          rowSpan={row.items.length}
          style={{ padding: 0 }}
        >
          <table className="inside-table text-sm">
            <tr>
              <td className="p-2 border">ARP :</td>
              <td className="p-2 border">{row.arp}</td>
            </tr>
            <tr>
              <td className="p-2 border">PIN :</td>
              <td className="p-2 border">{row.pin}</td>
            </tr>
            <tr>
              <td className="p-2 border">Account Name :</td>
              <td className="p-2 border">{row.account_name}</td>
            </tr>
            <tr>
              <td className="p-2 border">Effectivity :</td>
              <td className="p-2 border">{row.effectivity}</td>
            </tr>
          </table>
        </td>
      )}
      {index === 0 && (
        <td
          className="p-2 border"
          rowSpan={row.items.length}
          style={{ padding: 0 }}
        >
          <table className="inside-table text-sm">
            <tr>
              <td>Kind :</td>
              <td>{row.kind}</td>
            </tr>
            <tr>
              <td>Last Payment :</td>
              <td>{row.last_payment}</td>
            </tr>
          </table>
        </td>
      )}
      <td className="text-center p-2 border">
        {rptActualUse(item.actual_use)}
      </td>
      <td className="text-right p-2 border">
        {currencyFormat(item.assessed_value)}
      </td>
      {index === 0 && (
        <Fragment>
          <td className="text-center p-2 border">{`${row.bill_from_year} - ${row.bill_from_qtr}`}</td>
          <td className="p-2 border">
            <div
              style={{ display: "grid", gridTemplateColumns: "110px 80px" }}
              className="gap-2"
            >
              <div>
                <select
                  name="bill_to_year"
                  autoComplete="off"
                  value={row.bill_to_year}
                  defaultValue=""
                  onChange={(e) => handleDropDown(e, key_index)}
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option disabled>select item</option>
                  {row.years &&
                    row.years.length > 0 &&
                    row.years.map((i, idx) => (
                      <option key={idx} value={i.value}>
                        {i.text}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <select
                  name="bill_to_qtr"
                  autoComplete="off"
                  value={row.bill_to_qtr}
                  defaultValue=""
                  onChange={(e) => handleDropDown(e, key_index)}
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option disabled>select item</option>
                  {row.quarters &&
                    row.quarters.length > 0 &&
                    row.quarters.map((i, idx) => (
                      <option key={idx} value={i.value}>
                        {i.text}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </td>
          <td rowSpan={row.items.length} className="text-center p-2 border">
            <a
              href="#!"
              onClick={(e) => remove(e, row.arp)}
              title="Remove item"
              className="text-red-700"
            >
              <i className="fas fa-trash"></i>
            </a>
          </td>
        </Fragment>
      )}
    </tr>
  ));
};

const RequestBilling = (props) => {
  const [loading, setLoading] = useState(false);
  const [request_types, setRequest_types] = useState([]);
  const [items, setItems] = useState([]);
  const [name, setName] = useState();
  const [mobile_no, setMobile_no] = useState();
  const [address, setAddress] = useState();
  const [email_address, setEmail_address] = useState();
  const [valid_email, setValid_email] = useState(false);
  const [valid_mobile, setValid_mobile] = useState(false);
  const [agree, setAgree] = useState(false);
  // const [details, setDetails] = useState();
  const [request_type, setRequest_type] = useState();

  useEffect(() => {
    if (email_address) setValid_email(regexEmail.test(email_address));
    return () => console.log("Validate Email Address");
  }, [email_address]);

  useEffect(() => {
    if (mobile_no) setValid_mobile(regexMobile.test(mobile_no));
    return () => console.log("Validate Mobile No");
  }, [mobile_no]);

  const handleDropDown = (e, index) =>
    setItems(
      items.map((item, idx) => {
        console.log(e, item, idx);
        if (idx !== index) return item;
        return {
          ...item,
          [e.target.name]: e.target.value,
        };
      })
    );

  const searchProperty = (value) => {
    console.log(value, items);

    if (value && value !== "") {
      if (
        items.find(
          (_) => _.arp.trim().toLowerCase() === value.trim().toLowerCase()
        )
      ) {
        toast("Record already exists!", "", "info");
        return;
      }

      setLoading(true);
      setTimeout(async () => {
        await pgw
          .post(`/online/rpt-online/search`, { arp: value })
          .then((r) => {
            browserLogs(r);
            const { data, success } = r.data;
            if (success) {
              if (data.length > 0) {
                const {
                  arp,
                  pin,
                  account_name,
                  account_no,
                  kind,
                  last_payment,
                  effectivity,
                } = data[0];

                const bill_from_year = rptYear(last_payment, effectivity),
                  bill_from_qtr = rptQtr(last_payment, effectivity),
                  bill_to_year = rptYear(last_payment, effectivity),
                  _kind = rptKind(kind),
                  year_to = parseInt(moment().format("YYYY")) + 5;

                let temp = {
                  arp,
                  pin,
                  account_name,
                  account_no,
                  kind: _kind,
                  last_payment,
                  effectivity,
                  items: data,
                  bill_from_year,
                  bill_from_qtr,
                  bill_to_year,
                  bill_to_qtr: 4,
                  years: [],
                  quarters: [
                    { text: 1, value: 1 },
                    { text: 2, value: 2 },
                    { text: 3, value: 3 },
                    { text: 4, value: 4 },
                  ],
                };

                for (let i = temp.bill_from_year; i < year_to; i++) {
                  temp.years.push({ text: i, value: i });
                }
                setItems([...items, temp]);
              } else {
                toast("Record not found.", "", "info");
              }
            } else toast(data.error, null, "info");
          })
          .then(() => setLoading(false))
          .catch((e) => {
            setLoading(false);
            toast("Error encountered", "", "warning");
          });
      }, 500);
    }
  };

  const removeRptItem = (e, arp) => {
    confirm("Continue to remove item?", "Yes", "No").then((r) => {
      if (r.isConfirmed) {
        e.preventDefault();
        setItems(items.filter((_) => _.arp !== arp));
      }
    });
  };

  const isEnabled =
    items &&
    items.length > 0 &&
    name &&
    mobile_no &&
    email_address &&
    request_type &&
    valid_email &&
    valid_mobile &&
    address &&
    agree;

  const submit = () => {
    setLoading(true);
    // setDetails(JSON.stringify(items));

    const details = JSON.stringify(
      items.map((i) => {
        delete i["years"];
        delete i["quarters"];
        return i;
      })
    );

    setTimeout(async () => {
      let params = {
        items,
        name,
        mobile_no,
        email_address,
        request_type,
        valid_email,
        valid_mobile,
        address,
        agree,
        details,
      };

      params.items.forEach((i) => {
        delete i["years"];
        delete i["quarters"];
      });

      await pgw
        .post("/online/create-request", params)
        .then((res) => {
          const { success } = res.data;
          if (success) {
            toast("Success", "Record has been submitted", "success");
            window.location.reload();
          }
        })
        .then(() => setLoading(false))
        .catch((e) => {
          setLoading(false);
          toast("Error encountered", "", "warning");
        });
    }, 300);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(async () => {
      await pgw
        .get(environment.REACT_APP_URL_REQUEST_TYPE)
        .then((r) => {
          const { data } = r.data;
          setRequest_types(data);
          setRequest_type(data[0].value);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          setLoading(false);
          toast("Error encountered", "", "warning");
        });
    }, 500);
    return () => console.log("clean up");
  }, []);

  return (
    <Fragment>
      {loading && <Loader />}
      <div className="max-w-6xl mx-auto mb-10">
        <div className="w-full">
          <div className="p-5 border rounded mb-3">
            <div className="border-b p-2 mb-3">
              <div className="text-xl font-bold text-orange-500">
                Request Details
              </div>
              <em className="text-sm text-gray-400">
                Personal information of the requestor
              </em>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-3">
              <Input
                _class="col-md-5"
                max="50"
                label="Name of Requestor"
                value={name}
                required={true}
                onChange={setName}
              />
              <Input
                _class="col-md-7"
                max="100"
                label="Address"
                name="address"
                value={address}
                required={true}
                onChange={setAddress}
              />
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <Select
                label="Type of request"
                name="request_type"
                value={request_type}
                items={request_types}
                onChange={setRequest_type}
              />

              <Input
                type="number"
                max="13"
                label="Mobile Number"
                name="mobile_no"
                value={mobile_no}
                isValid={valid_mobile}
                required={true}
                isMobile={true}
                onChange={setMobile_no}
              />

              <Input
                type="email"
                max="100"
                label="Email Address"
                name="email_address"
                value={email_address}
                isValid={valid_email}
                required={true}
                isEmail={true}
                onChange={setEmail_address}
              />
            </div>
          </div>

          <div>
            {request_type && request_type === "rpt" && (
              <div className="border rounded p-5">
                <div className="p-2 mb-3 border-b">
                  <div className="text-xl font-bold text-orange-500">
                    Billing Items
                  </div>
                  <em className="text-sm text-gray-400">
                    Real property tax declaration details of the requestor
                  </em>
                </div>

                <table className="w-full">
                  <colgroup>
                    <col />
                    <col />
                    <col width="100" />
                    <col width="100" />
                    <col width="80" />
                    <col width="80" />
                    <col width="50" />
                  </colgroup>
                  <thead className="bg-green-700 text-white text-center text-sm">
                    <tr>
                      <td rowSpan="2" colSpan="2" className="p-2 border">
                        Property Details
                      </td>
                      <td rowSpan="2" className="p-2 border">
                        Actual Use
                      </td>
                      <td rowSpan="2" className="p-2 border">
                        Assessed Value
                      </td>
                      <td colSpan="2" className="p-2 border">
                        Billing
                      </td>
                      <td rowSpan="2" className="p-2 border"></td>
                    </tr>
                    <tr>
                      <td className="p-2 border">From</td>
                      <td className="p-2 border">To</td>
                    </tr>
                  </thead>
                  <tbody>
                    {items &&
                      items.map((item, index) => (
                        <RptRow
                          key={index}
                          key_index={index}
                          row={item}
                          remove={removeRptItem}
                          handleDropDown={handleDropDown}
                        />
                      ))}
                  </tbody>
                  <tfoot>
                    <tr className="bg-gray-200">
                      <td
                        colSpan="10"
                        className="p-2 border text-sm text-center"
                      >
                        <a
                          href="#!"
                          className="hover:text-orange-500"
                          onClick={(e) => {
                            e.preventDefault();
                            toastRPT(searchProperty);
                          }}
                        >
                          <i className="fas fa-plus"></i> Add Record
                        </a>
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <DataPrivacy
                  onChange={setAgree}
                  agree={agree}
                  withAgree={true}
                />

                <div
                  className="col-md-12 text-center border-top"
                  style={{ padding: 20, marginTop: 20 }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!isEnabled}
                    onClick={submit}
                  >
                    <i className="fas fa-paper-plane"></i> Submit Request
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RequestBilling;
